export default "__VITE_ASSET__f3bcfd16__"